import { render, staticRenderFns } from "./TDSButton.vue?vue&type=template&id=3891ee9e&scoped=true"
import script from "./TDSButton.vue?vue&type=script&lang=ts"
export * from "./TDSButton.vue?vue&type=script&lang=ts"
import style0 from "./TDSButton.vue?vue&type=style&index=0&id=3891ee9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3891ee9e",
  null
  
)

export default component.exports